export interface BankUssdEmergencyItem {
  id: string;
  bankName: string;
  shortName: string;
  freezeCode: string;
  generalUssd: string;
  blockAccountUssd: string;
  blockCardUssd: string;
  instructions: string;
  customerCare: string;
}

export const NIGERIAN_BANK_USSD_CODES: BankUssdEmergencyItem[] = [
  {
    id: 'gtbank',
    bankName: 'Guaranty Trust Bank (GTBank)',
    shortName: 'GTBank',
    freezeCode: '*737*911#',
    generalUssd: '*737#',
    blockAccountUssd: '*737*911#',
    blockCardUssd: '*737*51*74#',
    instructions: 'Dial *737*911# from any phone to lock account and debit card instantly.',
    customerCare: '08039003900',
  },
  {
    id: 'uba',
    bankName: 'United Bank for Africa (UBA)',
    shortName: 'UBA',
    freezeCode: '*919*9#',
    generalUssd: '*919#',
    blockAccountUssd: '*919*9#',
    blockCardUssd: '*919*10#',
    instructions: 'Dial *919*9# from any line and enter registered mobile number.',
    customerCare: '07002255822',
  },
  {
    id: 'zenith',
    bankName: 'Zenith Bank',
    shortName: 'Zenith',
    freezeCode: '*966*911#',
    generalUssd: '*966#',
    blockAccountUssd: '*966*911#',
    blockCardUssd: '*966*60#',
    instructions: 'Dial *966*911# from any phone, enter account number to lock profile.',
    customerCare: '012787000',
  },
  {
    id: 'firstbank',
    bankName: 'First Bank of Nigeria',
    shortName: 'FirstBank',
    freezeCode: '*894*911#',
    generalUssd: '*894#',
    blockAccountUssd: '*894*911#',
    blockCardUssd: '*894*911#',
    instructions: 'Dial *894*911# to deactivate FirstBank USSD and debit transactions immediately.',
    customerCare: '07080625000',
  },
  {
    id: 'access',
    bankName: 'Access Bank',
    shortName: 'Access',
    freezeCode: '*901*911#',
    generalUssd: '*901#',
    blockAccountUssd: '*901*911#',
    blockCardUssd: '*901*11#',
    instructions: 'Dial *901*911# from any phone and input phone number tied to account.',
    customerCare: '07003000000',
  },
  {
    id: 'stanbic',
    bankName: 'Stanbic IBTC Bank',
    shortName: 'Stanbic',
    freezeCode: '*909*911#',
    generalUssd: '*909#',
    blockAccountUssd: '*909*911#',
    blockCardUssd: '*909*29#',
    instructions: 'Dial *909*911# to freeze USSD banking access.',
    customerCare: '0700909909909',
  },
  {
    id: 'fidelity',
    bankName: 'Fidelity Bank',
    shortName: 'Fidelity',
    freezeCode: '*770*911#',
    generalUssd: '*770#',
    blockAccountUssd: '*770*911#',
    blockCardUssd: '*770*911#',
    instructions: 'Dial *770*911# and enter registered mobile number.',
    customerCare: '070034335489',
  },
  {
    id: 'opay',
    bankName: 'OPay Nigeria',
    shortName: 'OPay',
    freezeCode: '*955*911#',
    generalUssd: '*955#',
    blockAccountUssd: '*955*911#',
    blockCardUssd: 'In-app Security Center',
    instructions: 'Dial *955*911# or use Security Center in OPay app to block wallet.',
    customerCare: '07008888328',
  },
  {
    id: 'palmpay',
    bankName: 'PalmPay Nigeria',
    shortName: 'PalmPay',
    freezeCode: '*861*0#',
    generalUssd: '*861#',
    blockAccountUssd: '*861*0#',
    blockCardUssd: 'In-app Safety Center',
    instructions: 'Dial *861*0# to lock lost PalmPay account and wallet.',
    customerCare: '018886888',
  },
  {
    id: 'moniepoint',
    bankName: 'Moniepoint Microfinance Bank',
    shortName: 'Moniepoint',
    freezeCode: '*5573*911#',
    generalUssd: '*5573#',
    blockAccountUssd: '*5573*911#',
    blockCardUssd: '*5573*911#',
    instructions: 'Dial *5573*911# to stop transactions across all channels.',
    customerCare: '018889987',
  },
  {
    id: 'fcmb',
    bankName: 'First City Monument Bank (FCMB)',
    shortName: 'FCMB',
    freezeCode: '*329*911#',
    generalUssd: '*329#',
    blockAccountUssd: '*329*911#',
    blockCardUssd: '*329*911#',
    instructions: 'Dial *329*911# from any phone and enter account details.',
    customerCare: '07003290000',
  },
  {
    id: 'ecobank',
    bankName: 'Ecobank Nigeria',
    shortName: 'Ecobank',
    freezeCode: '*326*911#',
    generalUssd: '*326#',
    blockAccountUssd: '*326*911#',
    blockCardUssd: '*326*911#',
    instructions: 'Dial *326*911# to block digital channel transactions.',
    customerCare: '07005000000',
  },
  {
    id: 'union',
    bankName: 'Union Bank of Nigeria',
    shortName: 'UnionBank',
    freezeCode: '*826*911#',
    generalUssd: '*826#',
    blockAccountUssd: '*826*911#',
    blockCardUssd: '*826*911#',
    instructions: 'Dial *826*911# and enter mobile phone number.',
    customerCare: '07007007000',
  },
  {
    id: 'wema',
    bankName: 'Wema Bank / ALAT',
    shortName: 'Wema/ALAT',
    freezeCode: '*945*911#',
    generalUssd: '*945#',
    blockAccountUssd: '*945*911#',
    blockCardUssd: '*945*911#',
    instructions: 'Dial *945*911# to restrict USSD, cards, and web transactions.',
    customerCare: '070022552528',
  },
  {
    id: 'sterling',
    bankName: 'Sterling Bank',
    shortName: 'Sterling',
    freezeCode: '*822*911#',
    generalUssd: '*822#',
    blockAccountUssd: '*822*911#',
    blockCardUssd: '*822*911#',
    instructions: 'Dial *822*911# from any line to deactivate banking profiles.',
    customerCare: '07008220000',
  },
];

export const NIGERIAN_BANK_USSD_DIRECTORY = NIGERIAN_BANK_USSD_CODES;
